import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

import { Container } from "../../common/Container/Container";
import { BottomNavigator } from "./components/ButtonNavigator";
import { LeftMenu } from "./components/LeftMenu";

export function OrkaAppInstallationGuide() {
	const navigate = useNavigate();

	return (
		<Container navbarOrkaProps={{ white: true }} noFooter>
			<div className="resource-detail-container">
				<LeftMenu />
				<div className="main-content">
					<div className="resource-header">
						<IconButton
							className="icon-button back-button"
							onClick={() => {
								navigate("/resources");
							}}>
							<FaChevronLeft />
						</IconButton>
						<Typography className="normal-text">Back to Resources</Typography>
					</div>

					<Typography
						className="title-text bold resource-title"
						textAlign="center"
						id="introduction">
						Fly ORKA App Installation Guide
					</Typography>

					<div className="section-top">
						<Typography
							className="small-title-text bold black-text underline-on-hover-link"
							component="a"
							id="1-installing-fly-orka-on-ios"
							href="#1-installing-fly-orka-on-ios">
							1. Installing Fly ORKA on iOS
						</Typography>
					</div>

					<Typography className="normal-text first-paragraph-top">
						To install Fly ORKA on your iOS device, open the App Store, search
						for <span className="bold">Fly ORKA</span> or click directly on our{" "}
						<a target="_blank" href={process.env.REACT_APP_IOS_APP_LINK}>
							Fly ORKA on Apple App Store
						</a>{" "}
						link to access the app.
					</Typography>

					<Typography className="normal-text paragraph-top">
						Tap the download button. If prompted, authenticate using your Apple
						ID, Face ID, or Touch ID. Once the installation is complete, simply
						tap Open to launch Fly ORKA.
					</Typography>

					<div className="section-top">
						<Typography
							className="small-title-text bold black-text underline-on-hover-link"
							component="a"
							id="2-installing-fly-orka-on-android"
							href="#2-installing-fly-orka-on-android">
							2. Installing Fly ORKA on Android
						</Typography>
					</div>

					<Typography className="normal-text first-paragraph-top">
						To install Fly ORKA on your Android device, open the Google Play
						Store, search for <span className="bold">Fly ORKA</span> or click
						directly on our{" "}
						<a target="_blank" href={process.env.REACT_APP_ANDROID_APP_LINK}>
							Fly ORKA on Google Play Store
						</a>{" "}
						link to access the app.
					</Typography>

					<Typography className="normal-text paragraph-top">
						Tap the install button. Once the installation is complete, simply
						tap Open to launch Fly ORKA.
					</Typography>

					<Typography className="normal-text paragraph-top">
						If you encounter any issues during installation, please contact our
						support team at{" "}
						<a href="mailto:hello@flyorka.com">hello@flyorka.com</a>.
					</Typography>

					<BottomNavigator />
				</div>
				<div className="right-menu">
					<Typography className="big-text bold">Table of Contents</Typography>
					<div className="paragraph-top">
						<Typography
							component="a"
							href="#introduction"
							className="normal-text black-text underline-on-hover-link">
							Introduction
						</Typography>
					</div>
					<div>
						<Typography
							component="a"
							href="#1-installing-fly-orka-on-ios"
							className="normal-text black-text underline-on-hover-link">
							1. Installing Fly ORKA on iOS
						</Typography>
					</div>
					<div>
						<Typography
							component="a"
							href="#2-installing-fly-orka-on-android"
							className="normal-text black-text underline-on-hover-link">
							2. Installing Fly ORKA on Android
						</Typography>
					</div>
				</div>
			</div>
		</Container>
	);
}
